import { Platform, StyleSheet } from 'react-native';
import { brand } from 'src/theme/colors';

export const styles = StyleSheet.create({
  hoverTextContainer: {
    position: 'absolute',
    bottom: 0, // Posizionato sopra l'icona
    backgroundColor: brand.main.variations['lighterWater-3'],
    zIndex: 2000,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    gap: 8,
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: brand.main.water,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
